import script from "./FormLanguage.vue?vue&type=script&lang=js"
export * from "./FormLanguage.vue?vue&type=script&lang=js"

import "./FormLanguage.vue?vue&type=style&index=0&id=e5197c40&lang=scss"

const __exports__ = script;

export default __exports__